export interface Game {
  id: string;
  name: string;
  slug: string;
  category: string;
  description: string;
  fullDescription: string;
  developer: string;
  releaseDate: string;
  rating: number;
  ratingCount: number;
  image: string;
  tags: string[];
  features: string[];
  downloadUrl: string;
  fileSize: string;
  platforms: string[];
  isHot: boolean;
  isNew: boolean;
}

export const games: Game[] = [
  {
    id: 'hollow-knight',
    name: '空洞骑士',
    slug: 'hollow-knight',
    category: 'action-adventure',
    description: '在庞大的昆虫王国中展开史诗冒险，探索古老的地下世界，面对强大的敌人，揭开隐藏在圣巢深处的秘密。',
    fullDescription: '在《空洞骑士》中，你将扮演一位无名的小骑士，探索广阔而神秘的昆虫王国——圣巢。这片曾经繁荣的国度如今已被遗忘，沦为废墟。在探索过程中，你将遭遇各种奇特的生物和强大的敌人，学习新的技能和能力，揭开隐藏在圣巢深处的古老秘密。游戏拥有精美的2D手绘风格、流畅的战斗系统和深邃的世界观设定，是独立游戏中的经典之作。',
    developer: 'Team Cherry',
    releaseDate: '2017-02-24',
    rating: 4.9,
    ratingCount: 128000,
    image: 'https://readdy.ai/api/search-image?query=Hollow%20Knight%20game%20art%2C%20dark%20atmospheric%20underground%20insect%20kingdom%2C%20tiny%20knight%20with%20nail%20sword%2C%20hand%20drawn%202D%20art%20style%2C%20gothic%20architecture%2C%20blue%20and%20black%20color%20palette%2C%20mysterious%20ambient%20lighting%2C%20video%20game%20promotional%20art&width=800&height=500&seq=hollow-knight-game&orientation=landscape',
    tags: ['动作', '冒险', '类银河战士恶魔城', '2D'],
    features: ['精美手绘美术风格', '开放世界探索', '深度战斗系统', '丰富剧情故事', '原创音乐'],
    downloadUrl: '#',
    fileSize: '2.8 GB',
    platforms: ['Windows', 'Mac', 'Linux', 'Switch'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'stardew-valley',
    name: '星露谷物语',
    slug: 'stardew-valley',
    category: 'casual-puzzle',
    description: '逃离都市喧嚣，继承爷爷的农场，在星露谷中种田、钓鱼、挖矿，与村民交朋友，开启你的田园生活。',
    fullDescription: '《星露谷物语》是一款开放式乡村角色扮演游戏。你继承了爷爷在星露谷留下的老旧农场，带着爷爷留给你的几枚硬币和一些旧工具，开始了你的新生活。在这个充满活力的山谷中，你可以将自己的农场建设成理想中的模样，种植作物、饲养动物、制作手工艺品、开采矿物，还可以和山谷中的居民交朋友甚至结婚。',
    developer: 'ConcernedApe',
    releaseDate: '2016-02-27',
    rating: 4.8,
    ratingCount: 96000,
    image: 'https://readdy.ai/api/search-image?query=Stardew%20Valley%20game%20art%2C%20peaceful%20pixel%20art%20farm%20scene%2C%20colorful%20crops%20and%20animals%2C%20warm%20sunset%20lighting%2C%20cozy%20countryside%2C%20green%20fields%20and%20wooden%20house%2C%20retro%2016%20bit%20aesthetic&width=800&height=500&seq=stardew-valley-game&orientation=landscape',
    tags: ['模拟', '休闲', '像素风', '开放世界'],
    features: ['自由农场经营', '丰富社交系统', '多样的探索内容', '四季变化系统', '支持多人联机'],
    downloadUrl: '#',
    fileSize: '500 MB',
    platforms: ['Windows', 'Mac', 'Linux', 'Switch', 'iOS', 'Android'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'hades',
    name: '哈迪斯',
    slug: 'hades',
    category: 'action-adventure',
    description: '扮演冥王之子扎格柔斯，在随机生成的冥界迷宫中厮杀突围，借助奥林匹斯众神之力逃离地狱。',
    fullDescription: '《哈迪斯》是一款高强度的Roguelike动作游戏，由Supergiant Games开发。你扮演冥王哈迪斯之子扎格柔斯，你试图逃离冥界前往奥林匹斯山。在每次逃脱尝试中，你将穿越随机生成的房间，与各种神话生物和亡灵战斗，获得奥林匹斯众神的祝福来增强自己的力量。每次死亡都是一次新的开始，你将变得更强。',
    developer: 'Supergiant Games',
    releaseDate: '2020-09-17',
    rating: 4.9,
    ratingCount: 154000,
    image: 'https://readdy.ai/api/search-image?query=Hades%20game%20art%2C%20mythological%20underworld%20scene%2C%20Zagreus%20character%20with%20flaming%20feet%2C%20dark%20gothic%20palace%20interior%2C%20vibrant%20color%20contrast%2C%20stylized%20comic%20book%20art%2C%20Greek%20mythology%20aesthetic&width=800&height=500&seq=hades-game-art&orientation=landscape',
    tags: ['动作', 'Roguelike', '神话', '独立游戏'],
    features: ['高速流畅战斗', '丰富叙事设计', '随机地牢生成', '全语音对话', '多武器系统'],
    downloadUrl: '#',
    fileSize: '15 GB',
    platforms: ['Windows', 'Mac', 'Switch', 'PS4', 'PS5', 'Xbox'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'celeste',
    name: '蔚蓝',
    slug: 'celeste',
    category: 'action-adventure',
    description: '帮助玛德琳攀登蔚蓝山，在充满挑战的平台关卡中磨练技巧，同时探索她内心的故事与成长。',
    fullDescription: '《蔚蓝》是一款以登山为主题的精准平台跳跃游戏。你扮演少女玛德琳，她决定攀登传说中的蔚蓝山。在这段旅程中，你将面对数百个精心设计的挑战关卡，每一个都考验你的反应和技巧。但这不仅仅是关于登山的游戏，更是一个关于面对内心恐惧、克服自我怀疑的动人故事。',
    developer: 'Maddy Makes Games',
    releaseDate: '2018-01-25',
    rating: 4.8,
    ratingCount: 78000,
    image: 'https://readdy.ai/api/search-image?query=Celeste%20game%20art%2C%20pixel%20art%20mountain%20climbing%20scene%2C%20Madeline%20character%20with%20red%20hair%2C%20snowy%20mountain%20peaks%2C%20beautiful%20sunset%20sky%2C%20colorful%20retro%20pixel%20style%2C%20adventure%20platformer%20game&width=800&height=500&seq=celeste-game-art&orientation=landscape',
    tags: ['平台跳跃', '像素风', '剧情', '独立游戏'],
    features: ['精准平台操作', '感人故事叙述', '辅助模式可选', '隐藏关卡挑战', '原创动听配乐'],
    downloadUrl: '#',
    fileSize: '1.2 GB',
    platforms: ['Windows', 'Mac', 'Linux', 'Switch', 'PS4', 'Xbox'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'slay-the-spire',
    name: '杀戮尖塔',
    slug: 'slay-the-spire',
    category: 'strategy-simulation',
    description: '融合卡牌构筑与Roguelike的独特体验，在随机生成的尖塔中构筑你的牌组，挑战强大的敌人。',
    fullDescription: '《杀戮尖塔》是一款将卡牌游戏和Roguelike完美融合的独特作品。选择你的角色，开始攀登这座神秘的高塔。每一次攀登都是独特的旅程，你需要在战斗中收集卡牌、遗物和药水，构筑出属于你自己的强力牌组。游戏拥有三个各具特色的角色和数百张卡牌，每次游玩都有全新的策略体验。',
    developer: 'Mega Crit Games',
    releaseDate: '2019-01-23',
    rating: 4.9,
    ratingCount: 110000,
    image: 'https://readdy.ai/api/search-image?query=Slay%20the%20Spire%20game%20art%2C%20dark%20fantasy%20tower%20interior%2C%20card%20game%20battle%20scene%2C%20mysterious%20silhouette%20characters%2C%20purple%20and%20dark%20blue%20color%20scheme%2C%20atmospheric%20lighting%2C%20stylized%20illustration&width=800&height=500&seq=slay-the-spire-art&orientation=landscape',
    tags: ['卡牌', 'Roguelike', '策略', '独立游戏'],
    features: ['深度卡牌构筑', '随机地图生成', '三大角色体系', '数百张卡牌', '无尽模式挑战'],
    downloadUrl: '#',
    fileSize: '1 GB',
    platforms: ['Windows', 'Mac', 'Linux', 'Switch', 'iOS', 'Android'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'undertale',
    name: '传说之下',
    slug: 'undertale',
    category: 'rpg',
    description: '一款颠覆传统的角色扮演游戏，你可以选择战斗或者与怪物做朋友，每个选择都会改变故事的走向。',
    fullDescription: '《传说之下》是一款真正颠覆传统的角色扮演游戏。在这个独特的世界里，没有任何人必须死去——你可以选择战斗，也可以选择与敌人交流、成为朋友。游戏的战斗系统融合了弹幕躲避元素，故事深刻感人，角色生动有趣。你的每一个选择都会带来不同的结局，这款游戏将彻底改变你对RPG的看法。',
    developer: 'Toby Fox',
    releaseDate: '2015-09-15',
    rating: 4.8,
    ratingCount: 92000,
    image: 'https://readdy.ai/api/search-image?query=Undertale%20game%20art%2C%20retro%20pixel%20art%20underground%20world%2C%20colorful%20characters%2C%20heart%20soul%20mechanic%2C%20whimsical%20cave%20setting%2C%20warm%20and%20friendly%20atmosphere%2C%20iconic%20video%20game%20poster&width=800&height=500&seq=undertale-game-art&orientation=landscape',
    tags: ['RPG', '像素风', '剧情', '独立游戏'],
    features: ['革新战斗系统', '多结局分支', '深刻故事剧情', '大量秘密彩蛋', '经典原创音乐'],
    downloadUrl: '#',
    fileSize: '200 MB',
    platforms: ['Windows', 'Mac', 'Linux', 'Switch', 'PS4', 'Xbox'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'dead-cells',
    name: '死亡细胞',
    slug: 'dead-cells',
    category: 'action-adventure',
    description: '一款将Roguelike与类银河战士恶魔城完美结合的动作游戏，在随机生成的城堡中杀出一条血路。',
    fullDescription: '《死亡细胞》是一款Roguelike与类银河战士恶魔城风格相结合的动作平台游戏。你将扮演一个由细胞组成的无名英雄，在随机生成的城堡迷宫中探索和战斗。游戏拥有极其流畅的战斗手感和丰富的武器系统，每次死亡后的重生都会带来全新的地图布局。在不断尝试中解锁新的能力和装备，最终揭开这座诅咒之岛的秘密。',
    developer: 'Motion Twin',
    releaseDate: '2018-08-07',
    rating: 4.7,
    ratingCount: 85000,
    image: 'https://readdy.ai/api/search-image?query=Dead%20Cells%20game%20art%2C%20pixel%20art%20dungeon%20action%20scene%2C%20green%20flame%20headed%20character%2C%20dark%20castle%20interior%2C%20fast%20paced%20combat%2C%20vibrant%20color%20palette%2C%20gothic%20environment&width=800&height=500&seq=dead-cells-game-art&orientation=landscape',
    tags: ['动作', 'Roguelike', '类银河战士恶魔城', '像素风'],
    features: ['极致流畅战斗', '随机地图生成', '丰富装备系统', '挑战难度关卡', '多周目内容'],
    downloadUrl: '#',
    fileSize: '2 GB',
    platforms: ['Windows', 'Mac', 'Linux', 'Switch', 'PS4', 'iOS', 'Android'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'terraria',
    name: '泰拉瑞亚',
    slug: 'terraria',
    category: 'casual-puzzle',
    description: '在2D像素世界中冒险、建造、战斗，挖掘地底深处的宝藏，打造属于你自己的传奇世界。',
    fullDescription: '《泰拉瑞亚》是一个充满无限可能的2D沙盒冒险世界。你可以在这个世界中自由探索、挖掘资源、建造建筑、制作装备，挑战形形色色的Boss。从地表到地狱深渊，每个角落都隐藏着惊喜和危险。游戏拥有超过4000种物品、数百种敌人和Boss，以及丰富的NPC系统，让你的每一次冒险都独一无二。',
    developer: 'Re-Logic',
    releaseDate: '2011-05-16',
    rating: 4.8,
    ratingCount: 180000,
    image: 'https://readdy.ai/api/search-image?query=Terraria%20game%20art%2C%202D%20pixel%20art%20sandbox%20world%2C%20colorful%20biomes%20and%20buildings%2C%20adventure%20and%20crafting%20scene%2C%20underground%20cave%20exploration%2C%20bright%20pixel%20style%2C%20retro%20game%20aesthetic&width=800&height=500&seq=terraria-game-art&orientation=landscape',
    tags: ['沙盒', '冒险', '建造', '像素风'],
    features: ['无限世界探索', '深度建造系统', '海量物品收集', '史诗Boss战斗', '多人联机冒险'],
    downloadUrl: '#',
    fileSize: '500 MB',
    platforms: ['Windows', 'Mac', 'Linux', 'Switch', 'PS4', 'Xbox', 'iOS', 'Android'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'cuphead',
    name: '茶杯头',
    slug: 'cuphead',
    category: 'action-adventure',
    description: '致敬1930年代卡通动画风格的横版射击游戏，与茶杯头兄弟一起挑战各种奇幻Boss，偿还恶魔的债务。',
    fullDescription: '《茶杯头》是一款致敬1930年代美式卡通动画风格的横版动作射击游戏。游戏由Studio MDHR开发，所有画面全部采用手绘动画风格制作，搭配原汁原味的爵士配乐。你将扮演茶杯头和马克杯头两兄弟，在恶魔的赌局中输了灵魂之后，必须穿越各种奇异的世界，击败强大的Boss来偿还债务。',
    developer: 'Studio MDHR',
    releaseDate: '2017-09-29',
    rating: 4.7,
    ratingCount: 72000,
    image: 'https://readdy.ai/api/search-image?query=Cuphead%20game%20art%2C%201930s%20vintage%20cartoon%20animation%20style%2C%20run%20and%20gun%20action%2C%20hand%20drawn%20characters%2C%20retro%20rubber%20hose%20animation%2C%20colorful%20surreal%20boss%20battle%2C%20classic%20cartoon%20aesthetic&width=800&height=500&seq=cuphead-game-art&orientation=landscape',
    tags: ['动作', '射击', '手绘风格', '独立游戏'],
    features: ['手绘动画美术', '经典爵士配乐', '高难度Boss战', '双人合作模式', '隐藏关卡内容'],
    downloadUrl: '#',
    fileSize: '20 GB',
    platforms: ['Windows', 'Mac', 'Switch', 'PS4', 'Xbox'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'balatro',
    name: '小丑牌',
    slug: 'balatro',
    category: 'strategy-simulation',
    description: '将扑克牌玩法与Roguelike完美融合的创新之作，构筑强力牌组来挑战盲注，体验前所未有的策略快感。',
    fullDescription: '《小丑牌》是一款创新的扑克Roguelike游戏，将经典的德州扑克玩法与Roguelike牌组构筑深度结合。你需要通过打出合法的扑克牌型来获得筹码，击败一轮轮的"盲注"挑战。游戏中有150多种小丑牌可以提供各种强大的效果加成，还有塔罗牌、星球牌等特殊卡牌来改变游戏规则。每次游戏都是全新的策略体验。',
    developer: 'LocalThunk',
    releaseDate: '2024-02-20',
    rating: 4.9,
    ratingCount: 45000,
    image: 'https://readdy.ai/api/search-image?query=Balatro%20card%20game%20art%2C%20psychedelic%20poker%20cards%2C%20colorful%20joker%20cards%20design%2C%20dark%20background%20with%20neon%20lights%2C%20retro%20casino%20aesthetic%2C%20vibrant%20trippy%20color%20palette%2C%20surreal%20card%20game%20visual&width=800&height=500&seq=balatro-game-art&orientation=landscape',
    tags: ['卡牌', 'Roguelike', '扑克', '策略'],
    features: ['创新扑克机制', '海量小丑牌组合', '深度策略构筑', '无尽挑战模式', '收集解锁系统'],
    downloadUrl: '#',
    fileSize: '100 MB',
    platforms: ['Windows', 'Mac', 'Switch', 'iOS', 'Android'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'factorio',
    name: '异星工厂',
    slug: 'factorio',
    category: 'strategy-simulation',
    description: '在外星星球上建造和管理自动化工厂，从手工采矿到全自动生产线，体验工业文明的魅力。',
    fullDescription: '《异星工厂》是一款建造和管理自动化工厂的策略游戏。你降落在了一个资源丰富的外星星球上，你的目标是从零开始建造一个庞大而高效的自动化工厂。从简单的手工采矿开始，逐步研发和建造复杂的生产线、铁路系统和物流网络。同时你还需要防御星球上原生物种的攻击，保护你的工厂安全运转。',
    developer: 'Wube Software',
    releaseDate: '2020-08-14',
    rating: 4.9,
    ratingCount: 135000,
    image: 'https://readdy.ai/api/search-image?query=Factorio%20game%20art%2C%20massive%20industrial%20factory%20complex%2C%20conveyor%20belts%20and%20machines%2C%20top%20down%20view%2C%20alien%20planet%20landscape%2C%20orange%20and%20brown%20industrial%20color%20scheme%2C%20complex%20automation%20system&width=800&height=500&seq=factorio-game-art&orientation=landscape',
    tags: ['模拟', '策略', '自动化', '建造'],
    features: ['深度自动化系统', '无限工厂扩张', '科技树研发', '多人协作建造', '模块支持'],
    downloadUrl: '#',
    fileSize: '2.5 GB',
    platforms: ['Windows', 'Mac', 'Linux', 'Switch'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'spiritfarer',
    name: '灵魂摆渡人',
    slug: 'spiritfarer',
    category: 'casual-puzzle',
    description: '扮演灵魂摆渡人，建造并管理一艘渡船，照顾离世的灵魂，帮助他们完成最后的心愿，送他们前往彼岸。',
    fullDescription: '《灵魂摆渡人》是一款关于死亡的温馨管理游戏。你扮演灵魂摆渡人斯黛拉，驾驶着一艘神奇的渡船，在广阔的海域中航行。你将遇到各种离世的灵魂，邀请他们上船成为你的朋友。在船上，你可以建造各种设施、种植作物、烹饪美食，照顾这些灵魂直到他们准备好离开。这是一段关于友情、离别与成长的温暖旅程。',
    developer: 'Thunder Lotus Games',
    releaseDate: '2020-08-18',
    rating: 4.7,
    ratingCount: 36000,
    image: 'https://readdy.ai/api/search-image?query=Spiritfarer%20game%20art%2C%20beautiful%20hand%20drawn%20boat%20on%20sea%2C%20warm%20sunset%20colors%2C%20cozy%20ship%20interior%2C%20emotional%20storytelling%20game%2C%20soft%20watercolor%20art%20style%2C%20peaceful%20ocean%20atmosphere&width=800&height=500&seq=spiritfarer-game-art&orientation=landscape',
    tags: ['管理', '冒险', '剧情', '手绘风格'],
    features: ['感人故事体验', '自由船只建造', '丰富角色互动', '精美手绘美术', '平台探索元素'],
    downloadUrl: '#',
    fileSize: '7 GB',
    platforms: ['Windows', 'Mac', 'Linux', 'Switch', 'PS4', 'Xbox'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'outer-wilds',
    name: '星际拓荒',
    slug: 'outer-wilds',
    category: 'rpg',
    description: '在22分钟的时间循环中探索一个微缩太阳系，揭开古老外星文明留下的秘密，体验最独特的太空冒险。',
    fullDescription: '《星际拓荒》是一款开放世界的太空探索游戏，以22分钟的时间循环为核心机制。你是一个外星种族中最新加入太空计划的新成员，驾驶着简陋的飞船探索一个微缩的太阳系。每次22分钟结束后，时间会重置，但你所获得的知识会保留下来。你需要利用这些知识来解开古老的谜题，发现这个太阳系隐藏的真相。',
    developer: 'Mobius Digital',
    releaseDate: '2019-05-30',
    rating: 4.8,
    ratingCount: 42000,
    image: 'https://readdy.ai/api/search-image?query=Outer%20Wilds%20game%20art%2C%20tiny%20spaceship%20exploring%20miniature%20solar%20system%2C%20colorful%20planets%2C%20campfire%20under%20stars%2C%20mysterious%20alien%20ruins%2C%20beautiful%20cosmic%20landscape%2C%20indie%20game%20visual&width=800&height=500&seq=outer-wilds-art&orientation=landscape',
    tags: ['探索', '解谜', '太空', '独立游戏'],
    features: ['独特时间循环', '开放世界探索', '纯知识驱动进展', '深邃世界观设定', '原创音乐'],
    downloadUrl: '#',
    fileSize: '8 GB',
    platforms: ['Windows', 'PS4', 'PS5', 'Xbox', 'Switch'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'vampire-survivors',
    name: '吸血鬼幸存者',
    slug: 'vampire-survivors',
    category: 'casual-puzzle',
    description: '极简操作下的爽快割草体验，自动攻击配合强力武器进化，在怪物浪潮中生存下来，体验纯粹的爽快。',
    fullDescription: '《吸血鬼幸存者》是一款极简操作的时间生存游戏。你只需要控制角色的移动方向，角色会自动攻击周围的敌人。消灭怪物获得经验值来升级，从随机出现的武器和道具中选择来强化自己。随着游戏进行，武器会不断进化，最终你可以在成百上千的怪物群中体验无双割草的快感。简单、上瘾、解压。',
    developer: 'poncle',
    releaseDate: '2022-10-20',
    rating: 4.8,
    ratingCount: 60000,
    image: 'https://readdy.ai/api/search-image?query=Vampire%20Survivors%20game%20art%2C%20retro%20pixel%20art%20horde%20survival%2C%20massive%20monster%20swarm%2C%20colorful%20weapon%20effects%2C%20dark%20gothic%20castle%20setting%2C%20chaotic%20action%20scene%2C%20vibrant%20retro%20game%20visual&width=800&height=500&seq=vampire-survivors-art&orientation=landscape',
    tags: ['动作', '休闲', '像素风', 'Roguelike'],
    features: ['极简操作体验', '武器进化系统', '海量角色解锁', '多种地图场景', '无尽挑战模式'],
    downloadUrl: '#',
    fileSize: '300 MB',
    platforms: ['Windows', 'Mac', 'Switch', 'iOS', 'Android', 'Xbox'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'disco-elysium',
    name: '极乐迪斯科',
    slug: 'disco-elysium',
    category: 'rpg',
    description: '前所未有的侦探RPG体验，24种技能代表你内心的不同声音，在破案过程中探索人性的复杂与矛盾。',
    fullDescription: '《极乐迪斯科》是一款完全颠覆传统的开放世界侦探RPG。游戏中没有传统的战斗系统，取而代之的是一个深刻而复杂的技能对话系统。你的24种技能就像是脑海中不同的声音，它们会彼此对话、争论，帮助你（或误导你）解决案件。游戏的叙事深刻而富有哲理，触及政治、哲学、存在主义等深刻话题。',
    developer: 'ZA/UM',
    releaseDate: '2019-10-15',
    rating: 4.8,
    ratingCount: 58000,
    image: 'https://readdy.ai/api/search-image?query=Disco%20Elysium%20game%20art%2C%20painterly%20detective%20scene%2C%20gritty%20urban%20landscape%2C%20expressionist%20art%20style%2C%20melancholic%20atmosphere%2C%20detective%20in%20trench%20coat%2C%20European%20city%20aesthetic&width=800&height=500&seq=disco-elysium-art&orientation=landscape',
    tags: ['RPG', '侦探', '剧情', '独立游戏'],
    features: ['深度对话系统', '无战斗设计', '24种技能人格', '多重分支结局', '哲学思辨叙事'],
    downloadUrl: '#',
    fileSize: '20 GB',
    platforms: ['Windows', 'Mac', 'Switch', 'PS4', 'PS5', 'Xbox'],
    isHot: false,
    isNew: false,
  },
];

export const getGamesByCategory = (categorySlug: string): Game[] => {
  return games.filter(game => game.category === categorySlug);
};

export const getHotGames = (): Game[] => {
  return games.filter(game => game.isHot);
};

export const getNewGames = (): Game[] => {
  return games.filter(game => game.isNew);
};

export const getGameById = (id: string): Game | undefined => {
  return games.find(game => game.id === id);
};